class CartCount extends HTMLElement {
  connectedCallback() {
    // The initial count is rendered server side, so only re-render on change
    this.handleUpdateCart = (e) => {
      const count = e.detail.cart?.item_count;
      if (typeof count !== "number") return;

      this._setCount(count);
    };

    document.addEventListener("updateCart", this.handleUpdateCart);
  }

  disconnectedCallback() {
    document.removeEventListener("updateCart", this.handleUpdateCart);
  }

  _setCount(count) {
    const label =
      count === 1
        ? this.dataset.one
        : this.dataset.other.replace("[count]", count);

    this.innerHTML = `
      <span class="header__cart-count-number" aria-hidden="true">${count}</span>
      <span class="visually-hidden">${label}</span>`;
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
